var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"flex flex-col h-screen"},[_c('ConnectivityBar'),_vm._v(" "),_c('TopBar',{staticClass:"flex-none"}),_vm._v(" "),_c('Nuxt',{staticClass:"flex-grow"}),_vm._v(" "),_c('Footer',{staticClass:"flex-none"}),_vm._v(" "),_c('BottomBar',{staticClass:"flex-none"}),_vm._v(" "),_c('VodalMain')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }